import {AfterViewInit, Component, NgZone, OnInit, ViewChildren} from '@angular/core';
import {LoadingWheelService} from "../../root/loading/loading-wheel.service";
import {ActivatedRoute, Router} from "@angular/router";
import {HomeService} from "./home.service";
import * as moment from "moment";
import {GAService} from "../../root/ga/ga.service";
import {TranslateService} from "@ngx-translate/core";
import {ContractService} from "../../core/contract.service";
import {LegalDocumentService} from "../../core/legal_document_service";
import {CookieService} from "ngx-cookie";
import {SessionService} from "../../core/session.service";
import {NotificationService} from "../../root/toast/notification.service";
import {ContractStatesService} from "../../core/contract_states.service";

@Component({
    selector: 'home',
    templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit, AfterViewInit{

    pickupList:any;
    company:any;
    companyId:number;
    today:any = {};
    endLoading:boolean = false;
    eventCounter = 0;
    showMessageBanner:boolean = false;
    emailExecutiveAccount = '';
    CONTRACTS_CONTRACT_EXPIRED = "modal_contracts_contract_expired";
    NEW_FEATURE_TYC = "modal_new_feature_tyc";
    role;
    countryCode = '';
    countryName;
    showCountryPhone:boolean = false;
    countryPhone;

    constructor(private homeService: HomeService,
                private gaService:GAService,
                private loading:LoadingWheelService,
                private activatedRoute:ActivatedRoute,
                private router:Router,
                private translator:TranslateService,
                private zone: NgZone,
                private contractService:ContractService,
                private legalDocumentService:LegalDocumentService,
                private cookies: CookieService,
                private sessionService: SessionService,
                private notificationService:NotificationService,
                private statesServices:ContractStatesService) {
    }

    @ViewChildren('dspCards') dspCards;

    ngOnInit(): void {
        this.zone.run(() => {
            this.loadLanding();
            this.getToday();
        });

        if(!this.sessionService.getUserSession()){
            this.sessionService.getSubject().subscribe((message) => {
                if(!!message.done){
                    this.role = this.sessionService.getUserSession().userType;
                    this.showMessageStateLegalDocument();
                    this.openModalNewFeatureTyC();
                }
            });
        }else{
            this.role = this.sessionService.getUserSession().userType;
            this.showMessageStateLegalDocument();
            this.openModalNewFeatureTyC();
        }
    }

    ngGetPhoneFromCountry(){
        switch(this.countryCode) {
            case "BR": {
                this.showCountryPhone = true;
                this.countryPhone = "+55 11 4632-1021";
                break;
            }
            case "CL": {
                this.showCountryPhone = true;
                this.countryPhone = "+56 2 2391-7704";
                break;
            }
            case "CO": {
                this.showCountryPhone = true;
                this.countryPhone = "+57 1 646-6527";
                break;
            }
            default: {
                this.showCountryPhone = false;
                this.countryCode = "";
                this.countryName = "";
            }
        }
    }

    ngAfterViewInit(){
        this.dspCards = document.querySelectorAll("dsp-dashboard-card");
        this.dspCards.forEach((card) => {
            if(!!card.componentDidLoad){
                this.setSizeCard(card);
            }else{
                card.addEventListener("componentDidLoad", () => {
                    this.setSizeCard(card);
                });
            }
        });
    }

    setSizeCard(card){
        if(!!card.moreText){
            //TODO fix del lado de los webcomponents
            card.resizeCard(true);
        }
    }

    goTo(urlConfig:any, action:any, title:any){

        function buildUrl(urlConfig: any) {
            let url = '';
            for (let key of Object.keys(urlConfig)) {
                if(key == 'url'){
                    url = url + '/' + urlConfig[key];
                    break;
                }
                url = url + '/' + key + '/' + urlConfig[key];
            }
            return url;
        }
        this.gaService.notify("Autos_Home_Novedades",action,[this.getTitle(title)]);
        let url = buildUrl(urlConfig);
        this.router.navigateByUrl(url);
    }

    goToUrl(url:any, action, title){
        url = this.translator.instant(url);
        this.gaService.notify("Autos_Home_Novedades",action,[this.getTitle(title)]);
        window.open(url);
    }

    private getTitle(key) {
        if(!this.translator.translations["es"]){
            this.translator.getTranslation("es").subscribe(() => {
                return this.translator.translations["es"][key];
            })
        }else{
            return this.translator.translations["es"][key];
        }
    }

    private loadLanding() {
        this.loading.show();

        function buildPickUpList(pickupCountMap) {
            let puList = [];
            let days = [plusDate(0), plusDate(1), plusDate(2), plusDate(3), plusDate(4)];
            days.forEach(day => {
                puList.push({
                    day: day,
                    totalPu: !pickupCountMap[day.asString] ? 0 : pickupCountMap[day.asString]
                });
            });

            return puList;
        }

        function plusDate(days) {
            var d = new Date();
            d.setDate(d.getDate() + days);
            return {asDate: d, asString: (moment(d).format('YYYY-MM-DD'))};
        }

        this.activatedRoute.params.subscribe(params => {
            this.showCountryPhone = false;
            this.countryCode = "";
            this.countryName = "";
            let context= this;

            this.companyId = params['id'];
            let nowDate = moment().format('YYYYMMDD');
            this.homeService.getData(this.companyId, nowDate).subscribe(function (response) {
                localStorage.clear();
                context.company = response[0];
                localStorage.setItem('company',JSON.stringify(context.company));
                context.pickupList = buildPickUpList(response[1]);

                context.countryCode = context.company.countryCode;
                context.ngGetPhoneFromCountry();
                context.loading.hide();
            });
        });
    }

    private getToday() {
        let now = new Date();
        let currentMonth = now.getMonth() + 1;
        let currentMonthKey = (currentMonth < 10 ? "0" : "") + currentMonth;
        this.today.month = 'common.month.' + currentMonthKey;
        this.today.day = 'home.week.' + now.getDay();
        this.today.date = now.getDate();
    }

    showMessageStateLegalDocument(){
        this.showMessageBanner = false;

        this.contractService.get(this.companyId).subscribe(contracts => {
            if(!!contracts){
                for (let contract of contracts) {
                    this.legalDocumentService.getAll(this.companyId,contract.oid).subscribe(legalDocuments => {
                        let legalDocument = legalDocuments[0];
                        this.emailExecutiveAccount = contract.businessExecutiveContact;

                        if(legalDocument && this.isUserTypeCompany(this.role)){

                            if(this.statesServices.isEXPIRED(legalDocument.state)){
                                this.showMessageBanner = true;
                                this.openModalContractExpired();
                            }else {
                                this.cookies.remove(this.CONTRACTS_CONTRACT_EXPIRED);
                            }

                            this.statesServices.showNotification(legalDocument.state, legalDocument.daysPassedSinceLastModification);
                        }
                    });
                }
            }
        });
    }

    openModalContractExpired(){
        if(this.isUserTypeCompany(this.role)){
            let modalCookie = this.cookies.get(this.CONTRACTS_CONTRACT_EXPIRED);

            if (!modalCookie) {
                this.cookies.put(this.CONTRACTS_CONTRACT_EXPIRED, 'true');
                this.showModalContractExpired(true);

            }else if(modalCookie === 'true'){
                this.showModalContractExpired(true);
            }
        }
    }

    closeModalContractExpired() {
        this.cookies.put(this.CONTRACTS_CONTRACT_EXPIRED, 'false');

        //open mailto
        let aMailTo = document.createElement("a");
        aMailTo.href ="mailto:" + this.emailExecutiveAccount;
        aMailTo.click();

        this.showModalContractExpired(false);
    }

    showModalContractExpired(val){
        let modalContractExpired = document.getElementById("modalContractExpired");

        if(val){
            modalContractExpired.classList.add("-show-modal")
        }else{
            modalContractExpired.classList.remove("-show-modal");
        }
        return modalContractExpired.className;
    }

    openModalNewFeatureTyC(){
        //this modal will show only 5 times
        if(this.isUserTypeCompany(this.role)){
            let modalCookie = this.cookies.get(this.NEW_FEATURE_TYC);

            if (!modalCookie) {
                this.cookies.put(this.NEW_FEATURE_TYC, '4');
                this.showModalNewFeatureTyC(true);

            } else if (parseInt(modalCookie) > 0) {
                this.cookies.put(this.NEW_FEATURE_TYC, (parseInt(modalCookie)-1).toString());
                this.showModalNewFeatureTyC(true);
            }
        }
    }

    closeModalNewFeatureTyC() {
        this.cookies.put(this.NEW_FEATURE_TYC, '0');
        this.showModalNewFeatureTyC(false);
    }

    showModalNewFeatureTyC(val){
        let modalNewFeatureTyC = document.getElementById("modalNewFeatureTyC");

        if(val){
            modalNewFeatureTyC.classList.add("-show-modal");
        }else{
            modalNewFeatureTyC.classList.remove("-show-modal");
        }
        return modalNewFeatureTyC.className;
    }

    isUserTypeCompany(userRole){
        return userRole === 'COMPANY';
    }

}


// WEBPACK FOOTER //
// ./public/upgrade/feature/home/home.component.ts